<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>Opening Times</h3>
        <ul class="times-list">
          <li><strong>Monday - Saturday:</strong> 12-2 pm, 4:30-9 pm</li>
          <li><strong>Sunday:</strong> Closed</li>
        </ul>
      </div>

      <div class="footer-section">
        <h3>Sitemap</h3>
        <ul class="sitemap">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/our-food">Our Food</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
          <li><router-link to="/legal">Legal</router-link></li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      &copy; {{ new Date().getFullYear() }} Hooked Worcester All rights reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: 'RuggedSeparator',
  props: {
    isTop: {
      type: Boolean,
      default: true
    }
  },

}
</script>

<style scoped>
.footer {
  background-color: #222;
  color: #eee;
  padding: 2rem 1rem;
  font-family: Arial, sans-serif;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  flex: 1 1 250px;
  margin: 1rem 0;
}

.footer-section h3 {
  margin-bottom: 0.75rem;
  font-size: 1.2rem;
  border-bottom: 1px solid #444;
  padding-bottom: 0.3rem;
}

.times-list,
.sitemap {
  list-style: none;
  padding: 0;
}

.times-list li,
.sitemap li {
  margin: 0.3rem 0;
}

.sitemap li a {
  color: #eee;
  text-decoration: none;
}

.sitemap li a:hover {
  text-decoration: underline;
}

.footer-bottom {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.9rem;
  color: #aaa;
}
</style>
